import { Button, Result } from "antd";
import React from "react";

export const NoData = ({
  title = "No Record Found",
  subTitle = "Sorry,we did not find any matching record,click go back to continue",
  clickHandler,
}) => {
  return (
    <Result
      status="404"
      title={title}
      subTitle={subTitle}
      extra={
        <Button type="danger" shape="round" onClick={clickHandler}>
          Go Back
        </Button>
      }
    />
  );
};

